import Vue from 'vue'
import Router from 'vue-router'

// router modules
import root from './modules/root'
import core from './modules/core'
import management from './modules/management'
import fm from './modules/fm'
import fmmodule from './modules/fmmodule'

import guards from './guards'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    ...root,
    ...core,
    ...management,
    ...fm,
    ...fmmodule
  ],
  linkActiveClass: "active"
})

// register all guards
guards.forEach(guard => {
  router.beforeEach((to, from, next) => {
      guard(to, from, next)
  })
})

export default router
